import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCurrentUser, fetchCurrentUserHeap } from '../fetch/user';
import isNil from 'lodash/isNil';
import { JSON_PARSE_ERROR } from './consts';

export const getCurrentUser = createAsyncThunk(
  'user/getUserStatus',
  (_, { rejectWithValue }) =>
    fetchCurrentUser()
      .then(({ data }) => ({ currentUser: data }))
      .catch((err) => rejectWithValue({ error: err })),
  {
    condition: (_, { getState }) => {
      const { user } = getState();
      if (isNil(user) || (user.isLoading && user.isInit)) {
        return false;
      }
    },
  },
);

export const getCurrentUserProperties = createAsyncThunk('user/getUserProperties', (_, { rejectWithValue }) =>
  fetchCurrentUserHeap()
    .then(({ data }) => ({ properties: data }))
    .catch((err) => rejectWithValue({ error: err }), {
      condition: (_, { getState }) => {
        const { user } = getState();
        if (isNil(user) || (user.isLoading && user.isInit)) {
          return false;
        }
      },
    }),
);

const initialState = {
  isInit: false,
  isLoading: true,
  error: null,
  id: null,
  email: null,
  name: null,
  userAccess: {},
  username: null,
  features: null,
  properties: {},
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  extraReducers: {
    [getCurrentUser.pending]: (state) => {
      state.isLoading = true;
      state.isInit = true;
    },
    [getCurrentUser.fulfilled]: (state, { payload: { currentUser } }) => {
      const { id, email, name, userAccess, username, features } = currentUser;
      state.isLoading = false;
      state.id = id;
      state.email = email;
      state.name = name;
      state.userAccess = userAccess;
      state.username = username;
      state.features = features;
    },
    [getCurrentUser.rejected]: (state, { payload: { error } }) => {
      state.isLoading = false;
      state.error = error.message === JSON_PARSE_ERROR ? 'Error authenticating!' : error.message;
    },
    [getCurrentUserProperties.pending]: (state) => {
      state.isLoading = true;
      state.isInit = true;
    },
    [getCurrentUserProperties.rejected]: (state, { payload: { error } }) => {
      state.isLoading = false;
      state.error = error.message === JSON_PARSE_ERROR ? 'Error fetching user properties!' : error.message;
    },
    [getCurrentUserProperties.fulfilled]: (state, { payload: { properties } }) => {
      state.properties = properties;
    },
  },
});

export default userSlice.reducer;
